import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { pressRowLogos } from './pressRowLogos'

export const PressRow = () => {
  const { colors, mediaQueries, motion } = useTheme()

  const sharedImgStyles = css`
    object-fit: contain;
    mix-blend-mode: multiply;
    ${motion.transition('transform')};
    &:hover {
      transform: scale(1.1);
    }
  `

  return (
    <FlexBox
      className={cx(
        css`
          margin: 16px auto 60px;
          position: relative;
          width: 100%;
          padding: 32px 0;
          border: 1px solid ${colors.uiPearlExtraLight};
          border-left: none;
          border-right: none;
          gap: 4.1vw;
          flex-wrap: wrap;
          ${mediaQueries.mobileL} {
            margin: 44px auto 100px;
            padding: 60px 0;
          }
          ${mediaQueries.tabletL} {
            gap: 7.118vw;
          }
          ${mediaQueries.desktop} {
            gap: 82px;
          }
        `,
        'fade'
      )}
      centerAll
    >
      <div
        className={css`
          padding: 0 20px;
          position: absolute;
          inset: -12px auto auto 50%;
          transform: translateX(-50%);
          background-color: ${colors.uiWhite};
        `}
      >
        <Text
          className={css`
            opacity: 0.5;
          `}
          type="body"
          sizing={{ base: 'M', mobileL: 'L' }}
          align="center"
          color={colors.uiBrown}
        >
          As seen in:
        </Text>
      </div>
      {pressRowLogos.map((logo, i) => (
        <a key={i} href={logo.link} target="_blank" rel="noreferrer">
          <img
            className={cx(
              sharedImgStyles,
              css`
                max-height: 15px;
                display: ${!!logo.imgMobile ? 'none' : 'block'};
                ${mediaQueries.mobileL} {
                  display: block;
                }
                ${mediaQueries.tabletL} {
                  max-height: 21px;
                }
              `
            )}
            src={logo.imgDesktop}
            alt={logo.name}
          />
          {!!logo.imgMobile ? (
            <img
              className={cx(
                sharedImgStyles,
                css`
                  display: ${!!logo.imgMobile ? 'block' : 'none'};
                  max-height: 6.378vw;
                  ${mediaQueries.mobileL} {
                    display: none;
                  }
                `
              )}
              src={logo.imgMobile}
              alt={logo.name}
            />
          ) : null}
        </a>
      ))}
    </FlexBox>
  )
}
